import { customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_HEALTH_DASHBOARD_UPDATE_STATUS } from '../../../../webcomponents.constants';
import { GzHealthDashboardInsights } from './GzHealthDashboardInsights';
import { InsightsTemplatesStringKeys } from '../types';
import { translateFn } from '../../../../utils/translator.helper';
import { WidgetSectionItemSeverity } from '../../../../ui/gzWidgetSectionItem/types';

@customElement(WEB_COMPONENT_HEALTH_DASHBOARD_UPDATE_STATUS)
export class GzHealthDashboardUpdateStatusWebComponent extends GzHealthDashboardInsights {
  widgetKey = 'updateStatus';

  changedInfoBoxText = `${translateFn('You have <b>updates</b> for this widget!')}
          <br />
          <br />
          ${translateFn(
            'To experience the latest design, close the current widget and select the new ones in the Settings panel. Apply your changes and save the view.'
          )}`;

  strings = {
    sections: [
      {
        key: InsightsTemplatesStringKeys.PRODUCT_UPDATE,
        title: translateFn('Product Update Status'),
        items: [
          {
            key: InsightsTemplatesStringKeys.UPDATED,
            name: translateFn('Updated'),
            tooltipText: translateFn('Endpoints are up to date, and no new updates are currently available.'),
            severity: WidgetSectionItemSeverity.SUCCESS,
          },
          {
            key: InsightsTemplatesStringKeys.PENDING_RESTART,
            name: translateFn('Pending restart'),
            tooltipText: translateFn('Endpoints require a system restart to complete the update process.'),
            severity: WidgetSectionItemSeverity.WARNING,
          },
          {
            key: InsightsTemplatesStringKeys.UPDATE_DISABLED,
            name: translateFn('Update disabled'),
            tooltipText: translateFn('Product update option is disabled from the policy applied on endpoints.'),
            severity: WidgetSectionItemSeverity.WARNING,
          },
          {
            key: InsightsTemplatesStringKeys.OUTDATED,
            name: translateFn('Outdated'),
            tooltipText: translateFn('Endpoints were online within the past 24 hours but could not receive updates.'),
            severity: WidgetSectionItemSeverity.ERROR,
          },
        ],
      },
      {
        key: InsightsTemplatesStringKeys.SIGNATURE_UPDATE,
        title: translateFn('Security content update status'),
        items: [
          {
            key: InsightsTemplatesStringKeys.UPDATED,
            name: translateFn('Updated'),
            tooltipText: translateFn('Endpoints are up to date, and no new updates are currently available.'),
            severity: WidgetSectionItemSeverity.SUCCESS,
          },
          {
            key: InsightsTemplatesStringKeys.OFFLINE_MORE_THAN_ONE_DAY,
            name: translateFn('Offline more than 24 hours'),
            tooltipText: translateFn('Endpoints were offline for more than 24 hours.'),
            severity: WidgetSectionItemSeverity.WARNING,
          },
          {
            key: InsightsTemplatesStringKeys.UPDATE_DISABLED,
            name: translateFn('Update disabled'),
            tooltipText: translateFn('Security content update is disabled from the policy applied on endpoints.'),
            severity: WidgetSectionItemSeverity.WARNING,
          },
          {
            key: InsightsTemplatesStringKeys.OUTDATED,
            name: translateFn('Outdated'),
            tooltipText: translateFn('Endpoints were online within the past 24 hours but could not receive updates.'),
            severity: WidgetSectionItemSeverity.ERROR,
          },
        ],
      },
    ],
  };
}
